<div class="dialog-content">
  <div class="popup-part">
    @if (productStocksPerWarehouse().length > 0) {
      <div>
        <h3>
          {{
            'ERPWarehouse.warehouseStockForProduct'
              | translate: { productName: productName }
          }}
        </h3>
      </div>
      <div style="padding-top: 20px">
        <mat-table [dataSource]="productStocksPerWarehouse()">
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>
              {{ 'ERPWarehouse.warehouse' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.title }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="stock">
            <mat-header-cell *matHeaderCellDef>
              {{ 'ERPWarehouse.stock' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.stock }} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    } @else {
      <h3>
        {{
          'ERPWarehouse.noStockForProduct'
            | translate: { productName: productName }
        }}
      </h3>
    }
  </div>

  @if (window.innerWidth > 1000) {
    <mat-divider
      class="vertical-divider"
      [vertical]="true"
      style="height: 85%; margin: auto 0"
    ></mat-divider>
  } @else {
    <mat-divider
      class="vertical-divider"
      [vertical]="false"
      style="width: 85%; margin: 0 auto"
    ></mat-divider>
  }

  <div class="popup-part">
    @if (warehouseName !== '' && warehouseProductStocks().length > 0) {
      <div>
        <h3>
          {{
            'ERPWarehouse.productStockForWarehouse'
              | translate: { warehouseName: warehouseName }
          }}
        </h3>
      </div>
      <div style="padding-top: 20px">
        <mat-table [dataSource]="warehouseProductStocks()">
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>
              {{ 'ProdSchedule.product' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.productName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="stock">
            <mat-header-cell *matHeaderCellDef>
              {{ 'ERPWarehouse.stock' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.qty }} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    } @else if (warehouseName !== '' && warehouseProductStocks().length === 0) {
      <h3>
        {{
          'ERPWarehouse.noStockForWarehouse'
            | translate: { warehouseName: warehouseName }
        }}
      </h3>
    } @else {
      <h3>{{ 'ERPWarehouse.noSelectedWarehouse' | translate }}</h3>
    }
  </div>
</div>
